import React, { ComponentProps, ReactNode } from "react";
import * as RadixTooltip from "@radix-ui/react-tooltip";
import ToolTip from "./toolTip";

const ConditionalToolTip = ({
  condition,
  children,
  propClass = "",
  ...props
}: ComponentProps<typeof ToolTip> & {
  children: ReactNode;
  condition: string | boolean | ReactNode;
  propClass?: string;
  disableHoverableContent?: boolean;
}) => {
  const tooltipProps = { text: condition as string, propClass, ...props };

  if (condition) {
    return <ToolTip {...tooltipProps}>{children}</ToolTip>;
  }

  return <>{children}</>;
};

export default ConditionalToolTip;
